import { Comparison, Rule } from '@vendasta/automata';

const workflowStep = 'WorkflowStep';

// Delay Until variable paths should reference its step directly
export function reconnectPreviousRulesToEventHappenedPath(rule: Rule, stepId: string): Rule {
  if (rule.comparison === Comparison.Not) {
    rule.value = reconnectPreviousRulesToEventHappenedPath(rule.value as Rule, stepId);
    return rule;
  }

  if (rule.comparison === Comparison.And || rule.comparison === Comparison.Or) {
    const nestedRules: Rule[] = rule.value as Rule[];
    const newValue = nestedRules.map((r) => reconnectPreviousRulesToEventHappenedPath(r, stepId));
    rule.value = newValue;
    return rule;
  }

  const parsedVariablePath = parseVariablePath(rule.getVariablePath());
  if (parsedVariablePath.variableId && !parsedVariablePath.stepId) {
    const variablePath = buildVariablePath(parsedVariablePath.variableId, stepId);
    const newRule = new Rule(variablePath, rule.value, rule.next);
    newRule.comparison = rule.comparison;

    return newRule;
  }

  return rule;
}

export function buildVariablePath(variableId: string, stepId?: string): string {
  return stepId ? `{.${workflowStep}.${stepId}.${variableId}}` : `{.${variableId}}`;
}

function parseVariablePath(variablePath: string): { variableId: string; stepId: string } {
  const parts = variablePath?.split('.');
  if (parts?.length === 2) {
    return { stepId: '', variableId: parts[1].slice(0, -1) };
  }
  if (parts?.length === 4) {
    return { stepId: parts[2], variableId: parts[3].slice(0, -1) };
  }
  // unexpected variable path format
  return { stepId: '', variableId: '' };
}
